import MLToast from 'components/common/Toast/Toast';
import {
  useAddGearItemMutation,
  useMarkEssentialGearItemsMutation,
  useMarkGearItemMutation,
} from 'app/api/planApiSlice';
import GearChecklist from './GearChecklist';

// A Plan's saved Gear List: each answer and added item is saved as it's
// made. Read-only once the Plan has started.
const GearList = ({ planId, gearList, editable = true }) => {
  const { showToast } = MLToast();
  const [markGearItem] = useMarkGearItemMutation();
  const [markEssentialGearItems] = useMarkEssentialGearItemsMutation();
  const [addGearItem, { isLoading: isAdding }] = useAddGearItemMutation();

  const showError = (res) =>
    showToast(res.error?.data?.message || 'Something went wrong!', 'error');

  const handleMark = async (item, status) => {
    const res = await markGearItem({ planId, gearItemId: item.id, status });
    if (res.error) showError(res);
  };

  const handleMarkEssentials = async () => {
    const res = await markEssentialGearItems({ planId, status: 'TAKING' });
    if (res.error) showError(res);
  };

  const handleAdd = async (name) => {
    const res = await addGearItem({ planId, name });
    if (res.error) showError(res);
    return !res.error;
  };

  return (
    <GearChecklist
      items={gearList.map((item) => ({ ...item, id: item.gear_item_id }))}
      onMark={handleMark}
      onMarkEssentials={handleMarkEssentials}
      onAdd={handleAdd}
      editable={editable}
      isAdding={isAdding}
    />
  );
};

export default GearList;
